<template>
  <div class="content">
    <!-- 新增按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="primary" @click="kaihuBtn">新增轮播图</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="beforArr"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="类别" width="200" align="center">
          <template slot-scope="scope">
            <el-tag type="success">{{
              scope.row.type === 0
                ? "轮播图"
                : scope.row.type === 1
                ? "首页视频"
                : scope.row.type === 2
                ? "首页卡券入口"
                : scope.row.type === 3
                ? "领取商品卡券弹窗背景"
                : ""
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="资源地址" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>
                {{ scope.row.url }}
              </p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium" class="text-hide">{{
                  scope.row.url ? scope.row.url : "暂无"
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="预览" width="100" align="center">
          <template slot-scope="scope">
            <img
              :src="scope.row.url"
              alt
              style="width:100%"
              v-if="
                scope.row.type === 0 ||
                  scope.row.type == 2 ||
                  scope.row.type == 3
              "
            />
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column label="跳转链接配置" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.link ? scope.row.link : "暂无" }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="排序(从小到大排序)" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sort }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="是否关闭" align="center" width="180">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.status == 2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="statusChange(scope.row, $event)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteAdmin(scope.row)"
              v-if="scope.row.type === 0"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增表单 -->
    <el-dialog
      title="新增轮播图"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="跳转链接配置">
          <el-input
            v-model="form.link"
            auto-complete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
        <!-- 图片预览 -->
        <el-form-item label="图片预览">
          <!-- <div>已上传图片列表</div> -->
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="this.form.url"
              :preview-src-list="[this.form.url]"
            >
            </el-image>
          </div>
        </el-form-item>
      </el-form>
      <el-upload
        class="upload-demo"
        :action="action"
        :multiple="false"
        :on-success="handleSuccess_cover"
        :file-list="fileList"
        list-type="picture"
        name="formData"
        :limit="1"
      >
        <el-button size="small" type="primary"
          >点击上传图片(1张),会覆盖之前的</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，750px X 300px
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑表单 -->
    <el-dialog
      title="修改"
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item
          label="资源地址"
          v-if="form.type === 1 || form.type === 2 || form.type === 3"
        >
          <el-input v-model="form.url" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="兑换通道文字提醒" v-if="form.id === 15">
          <el-input
            v-model="form.message"
            auto-complete="off"
            clearable
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="跳转链接配置" v-if="form.type === 0">
          <el-input
            v-model="form.link"
            auto-complete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" v-if="form.type === 0">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
        <!-- 图片预览 -->
        <el-form-item
          label="图片预览"
          v-if="form.type === 0 || form.type === 2 || form.type === 3"
        >
          <!-- <div>已上传图片列表</div> -->
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="this.form.url"
              :preview-src-list="[this.form.url]"
            >
            </el-image>
          </div>
        </el-form-item>
      </el-form>
      <el-upload
        v-if="form.type === 0 || form.type === 2 || form.type === 3"
        class="upload-demo"
        :action="action"
        :multiple="false"
        :on-success="handleSuccess_cover"
        :file-list="fileList"
        list-type="picture"
        name="formData"
        :limit="1"
      >
        <el-button size="small" type="primary"
          >点击上传图片(1张),会覆盖之前的</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，750px X 300px
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectBanner,
  addBanner,
  updateBanner,
  deleteBanner,
  updateStatus,
} from "@/services/goods";
export default {
  data() {
    return {
      beforArr: [],
      inputTitle: "新增",
      cover: "",
      fileList: [], //上传列表
      action: "https://mini-xili.bboycc.cn/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" },
      ],
      form: {},
      dialogFormVisible: false,
      dialogFormVisible2: false,
    };
  },
  created() {
    // 查询用户登陆数据
    this.selectApi();
  },
  methods: {
    // 查询
    selectApi() {
      selectBanner().then((resp) => {
        console.log(resp.data);
        this.loading = false;
        this.beforArr = resp.data;
      });
    },
    // 新增按钮
    kaihuBtn() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
      this.fileList = [];
    },
    ejectupdataGoods(row) {
      console.log(row);
      this.dialogFormVisible2 = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },
    /* 修改状态 */
    statusChange(row, event) {
      console.log(row, event);
      let status = 1;
      if (event) {
        status = 2;
      }
      updateStatus(row.id, status).then((res) => {
        console.log(res);
        this.selectApi();
      });
    },
    /* 上传图片 */
    handleSuccess_cover(e) {
      console.log(e.data);
      this.form.url = e.data;
      // console.log(this.form);
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      if (this.form.url == "" || this.form.url == null) {
        this.$message.error("请上传图片");
        return;
      }
      if (this.form.sort == "" || this.form.sort == null) {
        this.form.sort = 0;
      }
      if (this.form.link == "" || this.form.link == null) {
        this.form.link = "";
      }
      if (this.inputTitle == "新增") {
        addBanner(this.form.url, this.form.link, this.form.sort).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "新增轮播图成功!",
            });
            this.selectApi();
          } else {
            this.$message({
              type: "info",
              message: "网路错误",
            });
          }
        });
        return;
      }

      updateBanner(this.form).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.dialogFormVisible2 = false;
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.selectApi();
        } else {
          this.$message({
            type: "info",
            message: "网络错误",
          });
        }
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteBanner(row.id).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectApi();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
